<template>
  <h-frame type="left">
    <div class="threeSolidLeft">
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">
            实有人口
            <!-- <div class="titleMore">
            更多
          </div> -->
          </div>
        </x-title>
        <leftEchartsPeople
          @click="leftItemClick({ name: '人口' })"
        ></leftEchartsPeople>
        <div class="leftpeople">
          <div class="yellowColor">人户一致标志</div>
          <div class="peopleecharts">
            <div class="oneBox">
              <div class="oneItem">
                <span class="bluecolore">一致:</span>{{ yestype }}
              </div>
              <div class="oneItem">
                <span class="bluecolore">不一致:</span>{{ notype }}
              </div>
            </div>
            <div class="oneBluebg">
              <div class="bluecount" :style="{ width: datawidth + '%' }">
                {{ yestype }}
              </div>
              <!-- :style="{width:(102+10)/100*102}"
            :style="{width:(notype+yestype)/100*yestype+'%'}"
            -->
              <div class="noBlue">{{ notype }}</div>
            </div>
          </div>
          <!-- <threeechartsone></threeechartsone> -->
        </div>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">
            实有房屋
            <!-- <div class="titleMore">更多</div> -->
          </div>
        </x-title>
        <threeechartshouse
          @click="leftItemClick({ name: '房屋' })"
        ></threeechartshouse>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">
            实有单位
            <!-- <div class="titleMore">
            更多
          </div> -->
          </div>
        </x-title>
        <threechartsunit
          @click="leftItemClick({ name: '单位' })"
        ></threechartsunit>
      </div>
      <!-- <div class="echarts" id="echartsbottomLeft"></div> -->
    </div>
  </h-frame>
</template>
<script>
import {
  defineComponent,
  inject,
  reactive,
  toRefs,
  computed,
  watchEffect,
  nextTick,
} from "vue";
import { useRouter } from "vue-router";
// import * as echarts from "echarts";
import leftEchartsPeople from "./leftEchartsPeople";
import threeechartshouse from "./threeechartshouse";
import threechartsunit from "./threechartsunit";
// import threeechartsone from "./threeechartsone";
import { prisonHouseHoldType } from "@/api/threeSolid/threeSolidHome.js";
import { useContext, createContext } from "@/hooks/core/useContext.js";
export default defineComponent({
  name: "",
  components: {
    leftEchartsPeople,
    threeechartshouse,
    threechartsunit,
    // threeechartsone
  },
  props: {},
  setup(props) {
    const data = reactive({
      notype: 0,
      yestype: 0,
      datawidth: 0,
    });
    const refData = toRefs(data);
    const router = useRouter();
    const regionInfo = inject("region");
    watchEffect(() => {
      if (regionInfo.regionList) {
        nextTick(() => {
          numberall();
        });
      }
    });
    const leftItemClick = (val) => {
      switch (val.name) {
        case "人口":
          router.push("DemographicInformation");
          break;
        case "房屋":
          router.push("UnitInformation");
          break;
        case "单位":
          router.push("UnitInformation");
          break;
        default:
          break;
      }
    };
    const numberall = async () => {
      const param = {
        regionIds: regionInfo.regionList.toString(),
      };
      const res = await prisonHouseHoldType(param);
      const no = [];
      const yes = [];
      res.data.forEach((item) => {
        if (item.name === "一致") {
          yes.push(item.value);
        } else {
          no.push(item.value);
        }
      });
      if (no[0]) {
        data.notype = parseInt(no[0]);
      } else {
        data.notype = 0;
      }
      if (yes[0]) {
        data.yestype = parseInt(yes[0]);
      } else {
        data.yestype = 0;
      }
      if (data.yestype + data.notype === 0) {
        data.datawidth = 50;
      } else {
        data.datawidth = (100 / (data.yestype + data.notype)) * data.yestype;
      }
    };
    numberall();
    // echarts

    return { ...refData, leftItemClick };
  },
});
</script>
<style lang="scss" scoped>
.threeSolidLeft {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  padding-top: 15px;
  overflow: auto;
  color: white;
  display: grid;
  grid-template-rows: 40% 30% 30%;
  // .itemDetail {
  //   height: 33%;
  // }
  .titleWidth {
    width: 100%;
  }
  .leftpeople {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    .yellowColor {
      width: 100%;
      text-align: center;
      color: #f3ce61;
      line-height: 40px;
    }
    .peopleecharts {
      display: flex;
      flex-direction: column;

      .oneBox {
        display: flex;
        justify-content: space-between;
        line-height: 30px;
        .bluecolore {
          color: #91c8ff;
        }
      }
      .oneBluebg {
        width: 100%;
        height: 30px;
        background: rgba(0, 143, 187, 1);
        border-radius: 4px;
        position: relative;

        .bluecount {
          width: 200px;
          text-align: center;
          height: 100%;
          position: absolute;
          border-radius: 4px;
          box-shadow: 0 0 10px 3px #00c9fa inset;
          background: #00a8ec;
          z-index: 2;
          line-height: 30px;
        }
        .noBlue {
          position: absolute;
          right: 20px;
          line-height: 30px;
        }
      }
    }
  }
  //
  .titleMore {
    float: right;
    cursor: pointer;
    // margin-right: 15px;
    background: #5189b4;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 14px;
  }
}
</style>
